<template>
  <div class="personal_center_header">
    <div class="header_box">
      <div class="left_box">
        <router-link to="/home">
          <img class="logo_img" :src="webConfig.logoFull || ''" v-if="webConfig" />
        </router-link>
         <!-- 园区切换 -->
<!--        <park_switch v-if="parkInfo && path.indexOf('service_provider') === -1" />-->
        <div class="nav_box">
          <router-link to="/personal_center/park_user">用户</router-link>
          <router-link to="/personal_center/enterprise">企业</router-link>
          <router-link to="/personal_center/service_provider">服务商</router-link>
          <router-link to="/personal_center/account_settings">账户设置</router-link>
          <router-link to="/personal_center/help">帮助中心</router-link>
        </div>
        <!-- <div class="search_box">
          <el-input placeholder="请输入搜索内容" v-model="searchVal">
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div> -->
      </div>
      <div class="right_box">
        <dl>
          <template v-if="!info">
            <dd>
              <router-link to="/login" class="link">登录</router-link>
            </dd>
            <dd>
              <router-link to="/register" class="link">注册</router-link>
            </dd>
          </template>
          <template v-else>
            <dd>
              <el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                  <span>{{info.user_name}}</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">个人中心</el-dropdown-item>
                  <el-dropdown-item command="b">账户设置</el-dropdown-item>
                  <el-dropdown-item command="c">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </dd>
          </template>
        </dl>
        <el-button type="primary" @click="putDemand">发布需求</el-button>
      </div>
    </div>
    <putDemand :dialogParams="dialogParams"></putDemand>
  </div>
</template>

<script>
import putDemand from "@/components/put_demand/put_demand";
import park_switch from "@/components/park/park_switch.vue";
export default {
  name: "personalHeader",
  components: {
    putDemand,
    park_switch
  },
  data() {
    return {
      searchVal: "",
      islogin: true, //判断是否登录
      dialogParams: {
        dialogFormVisible: false
      }
    };
  },
  created() {
    this.common.getUserInfo(true);
    this.common.getParkInfo(true);
    this.common.getEnterpriseInfo();
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    parkInfo(){
      return this.$store.state.parkInfo;
    },
    path(){
      return this.$route.path
    },
    webConfig() {
      return this.$store.state.webConfig;
    }
  },
  methods: {
    /*下拉菜单*/
    handleCommand(com) {
      if (com === "a") {
        this.$router.push({
          name: "personal_center"
        });
      } else if (com === "b") {
        this.$router.push({
          name: "account_settings"
        });
      } else if (com === "c") {
        this.common.exitLogin();
      }
    },
    putDemand() {
      this.dialogParams.dialogFormVisible = true;
    }
  }
};
</script>

<style lang="scss">
.personal_center_header {
  background: #fff;
  border-bottom: 1px #e9e9e9 solid;
  .header_box {
    width: 1200px;
    height: 64px;
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .left_box {
      display: flex;
      flex: 1;
      align-items: center;
      margin-right: 50px;
      .logo_img {
        width: 137px;
        height: 40px;
        object-fit: contain;
      }
      .nav_box {
        display: flex;
        margin-left: 100px;
        a {
          line-height: 64px;
          font-size: 16px;
          color: #333333;
          margin-right: 60px;
        }
        a:last-child {
          margin-right: 0px;
        }
        .router-link-active {
          font-weight: bold;
          border-bottom: 3px #4C84FF solid;
        }
      }
      .search_box {
        display: flex;
        .el-input__inner {
          width: 184px;
          height: 32px;
          border: 1px solid #cbcede;
          border-radius: 16px;
          font-size: 12px;
        }
      }
    }
    //登录
    .right_box {
      display: flex;
      align-items: center;
      dl {
        display: flex;
        /*flex-wrap: wrap;*/
        dd {
          border-right: 1px solid #3b4152;
          line-height: 16px;
          padding: 0 14px;
          .link {
            color: #000;
            font-size: 14px;
          }
          .link:hover {
            color: #ff733c;
          }
        }
        dd:last-child {
          border: 0px;
        }
        dt {
          margin-left: 20px;
          .link {
            color: #000;
            font-size: 14px;
          }
          .link:hover {
            color: #ff733c;
          }
        }
      }
      .el-dropdown-link {
        span {
          max-width: 150px;
          overflow: hidden;
          display: inline-block;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
